export const FETCH_CHARGEBACK_DATA_REQUEST = 'FETCH_CHARGEBACK_DATA_REQUEST';
export const FETCH_CHARGEBACK_DATA_SUCCESS = 'FETCH_CHARGEBACK_DATA_SUCCESS';
export const FETCH_CHARGEBACK_DATA_FAILURE = 'FETCH_CHARGEBACK_DATA_FAILURE';

export const FETCH_CHARGEBACK_DETAILS_REQUEST =
    'FETCH_CHARGEBACK_DETAILS_REQUEST';
export const FETCH_CHARGEBACK_DETAILS_SUCCESS =
    'FETCH_CHARGEBACK_DETAILS_SUCCESS';
export const FETCH_CHARGEBACK_DETAILS_FAILURE =
    'FETCH_CHARGEBACK_DETAILS_FAILURE';

export const VALIDATE_CHARGEBACK_REQUEST = 'VALIDATE_CHARGEBACK_REQUEST';
export const VALIDATE_CHARGEBACK_SUCCESS = 'VALIDATE_CHARGEBACK_SUCCESS';
export const VALIDATE_CHARGEBACK_FAILURE = 'VALIDATE_CHARGEBACK_FAILURE';

export const RAISE_CHARGEBACK_REQUEST = 'RAISE_CHARGEBACK_REQUEST';
export const RAISE_CHARGEBACK_SUCCESS = 'RAISE_CHARGEBACK_SUCCESS';
export const RAISE_CHARGEBACK_FAILURE = 'RAISE_CHARGEBACK_FAILURE';

export const CHARGEBACK_AGENT_ACTION_REQUEST =
    'CHARGEBACK_AGENT_ACTION_REQUEST';
export const CHARGEBACK_AGENT_ACTION_SUCCESS =
    'CHARGEBACK_AGENT_ACTION_SUCCESS';
export const CHARGEBACK_AGENT_ACTION_FAILURE =
    'CHARGEBACK_AGENT_ACTION_FAILURE';

export const CHARGEBACK_MERCHANT_ACTION_REQUEST =
    'CHARGEBACK_MERCHANT_ACTION_REQUEST';
export const CHARGEBACK_MERCHANT_ACTION_SUCCESS =
    'CHARGEBACK_MERCHANT_ACTION_SUCCESS';
export const CHARGEBACK_MERCHANT_ACTION_FAILURE =
    'CHARGEBACK_MERCHANT_ACTION_FAILURE';

export const GENERATE_CHARGEBACK_REPORT_REQUEST =
    'GENERATE_CHARGEBACK_REPORT_REQUEST';
export const GENERATE_CHARGEBACK_REPORT_SUCCESS =
    'GENERATE_CHARGEBACK_REPORT_SUCCESS';
export const GENERATE_CHARGEBACK_REPORT_ERROR =
    'GENERATE_CHARGEBACK_REPORT_ERROR';
export const GET_ACTIVE_CHARGEBACK_REPORT_REQUEST =
    'GET_ACTIVE_CHARGEBACK_REPORT_REQUEST';
export const GET_ACTIVE_CHARGEBACK_REPORT_SUCCESS =
    'GET_ACTIVE_CHARGEBACK_REPORT_SUCCESS';
export const GET_ACTIVE_CHARGEBACK_REPORT_ERROR =
    'GET_ACTIVE_CHARGEBACK_REPORT_ERROR';
export const DOWNLOAD_CHARGEBACK_REPORT_REQUEST =
    'DOWNLOAD_CHARGEBACK_REPORT_REQUEST';
export const DOWNLOAD_CHARGEBACK_REPORT_SUCCESS =
    'DOWNLOAD_CHARGEBACK_REPORT_SUCCESS';
export const DOWNLOAD_CHARGEBACK_REPORT_ERROR =
    'DOWNLOAD_CHARGEBACK_REPORT_ERROR';

// refund dispute status constants (possibilities).
export const REFUND_DISPUTE_REQUEST =
    'REFUND_DISPUTE_REQUEST';
export const REFUND_DISPUTE_SUCCESS =
    'REFUND_DISPUTE_SUCCESS';
export const REFUND_DISPUTE_FAILURE =
    'REFUND_DISPUTE_FAILURE';


export const CHECK_DISPUTE_STATUS_REQUEST = 'CHECK_DISPUTE_STATUS_REQUEST';
export const CHECK_DISPUTE_STATUS_SUCCESS = 'CHECK_DISPUTE_STATUS_SUCCESS';
export const CHECK_DISPUTE_STATUS_FAILURE = 'CHECK_DISPUTE_STATUS_FAILURE';


export const RESET_FIND_TRANSACTION_FORM = 'RESET_FIND_TRANSACTION_FORM';
export const RESET_RAISE_CHARGEBACK_FORM = 'RESET_RAISE_CHARGEBACK_FORM';
